import { Component, Input, OnInit } from '@angular/core';
import { MonitorTaskStatusEnum } from '../../../models/price-monitoring-task/enums/MonitorTaskStatusEnum';
import { MonitorStatusTask } from '../../../models/price-monitoring-task/MonitorStatusTask';

@Component({
  selector: 'app-price-monitoring-task-status',
  standalone: false,
  templateUrl: './price-monitoring-task-status.component.html'
})
export class PriceMonitoringTaskStatusComponent implements OnInit {
  @Input({ required: true }) status: MonitorStatusTask;
  @Input() isAmbassador: boolean = false;
  monitorTaskStatusEnum = MonitorTaskStatusEnum;

  constructor() { }

  ngOnInit() {
  }

}
